import instance from '../axios'

export const BusinessInfoApis = {
  getBusinessInfo: () => instance.get(`/v1/corporate/info`),
  getBusinessInfoDetail: () => instance.get(`/v1/corporate/info/detail`),
  getBusinessCheck: () => instance.get(`/v1/corporate/info/check`),
}
